<template>
	<div class="page-qa-engine">
		<!-- 设备信息 -->
		<div class="device-header">
			<div class="device-left">
				<img class="device-icon" :src="ossPondHost + 'img/xiazeng_icon.png'" />
				<div class="device-light-btn" @click="onclickLightBtn">亮灯</div>
			</div>
			<div class="device-num">
				<div>imei: {{ info.displayImei }}</div>
				<div>iccid: {{ info.displayIccid }}</div>
			</div>
		</div>

		<!-- 质检步骤 -->
		<div class="steps">
			<!-- 步骤1: 录入设备编号 -->
			<div class="step-item">
				<div class="step-left">
					<div class="step-info">
						<div class="step-label">1.录入设备编号</div>
						<div v-if="step1Status == 1 && uniqueId" class="step-sub">（{{ uniqueId }}）</div>
					</div>
					<span v-if="step1Status == 3" class="step-icon loading"><Loading type="spinner" size="0.2rem" /></span>
					<i v-else-if="step1Status == 1" class="step-icon van-icon van-icon-checked"></i>
					<i v-else-if="step1Status == 2" class="step-icon err van-icon van-icon-clear"></i>
				</div>
				<div class="step-action">
					<div v-if="step5Status == 1" class="step-text">已完成</div>
					<div v-else class="step-action-btns">
						<div class="step-btn" @click="onclickManualBtn">手动输入</div>
						<div class="step-btn" @click="onclickScanBtn">扫码</div>
					</div>
				</div>
			</div>

			<!-- 步骤2: 远程打样测试 -->
			<div class="step-item">
				<div class="step-left">
					<div class="step-info">
						<div class="step-label">2.远程打样测试</div>
						<div v-if="step2Status == 2 && step2FailReason" class="step-sub fail">{{ step2FailReason }}</div>
					</div>
					<span v-if="step2Status == 3" class="step-icon loading"><Loading type="spinner" size="0.2rem" /></span>
					<i v-else-if="step2Status == 1" class="step-icon van-icon van-icon-checked"></i>
					<i v-else-if="step2Status == 2" class="step-icon err van-icon van-icon-clear"></i>
				</div>
				<div class="step-action">
					<div v-if="step5Status == 1" class="step-text">已完成</div>
					<div v-else-if="step2Status == 3" class="step-text yellow">检测中</div>
					<div v-else-if="step2Status == 0" class="step-btn" @click="onclickRemoteTestBtn">检测</div>
					<div v-else class="step-btn" @click="onclickRemoteTestBtn">重检</div>
				</div>
			</div>

			<!-- 步骤2: 人工确认打样信息 -->
			<div v-if="step2Status == 1" class="confirm-bar" @click="openMediaModal">
				<span class="confirm-text">人工确认打样信息</span>
				<span class="confirm-btn">去查看</span>
			</div>

			<!-- 步骤3: 手动按键测试 -->
			<div class="step-item">
				<div class="step-left">
					<div class="step-label">3.手动按键测试</div>
					<i v-if="step3Status == 1" class="step-icon van-icon van-icon-checked"></i>
				</div>
				<div class="step-action">
					<div v-if="step3Status == 1" class="step-text">已完成</div>
					<div v-else class="step-text">待手动按键</div>
				</div>
			</div>

			<!-- 步骤4: 信号强度 -->
			<div class="step-item">
				<div class="step-left">
					<div class="step-info">
						<div class="step-label">4.信号强度</div>
						<div v-if="step4Status == 2" class="step-sub fail">当前信号 {{ displaySignal }}，要求≥{{ signalRequired }}</div>
					</div>
					<i v-if="step4Status == 1" class="step-icon van-icon van-icon-checked"></i>
					<i v-else-if="step4Status == 2" class="step-icon err van-icon van-icon-clear"></i>
				</div>
				<div class="step-action">
					<div v-if="step4Status == 1" class="step-text">已通过</div>
					<div v-else-if="step4Status == 2" class="step-text">不通过</div>
				</div>
			</div>

			<!-- 步骤5: 重启并切换到线上环境 -->
			<div :class="['step-item', { disabled: !firstFourDone }]">
				<div class="step-left">
					<div class="step-info">
						<div class="step-label">5.重启并切换到线上环境</div>
						<div v-if="step5Status == 2" class="step-sub fail">注册超时，请重试</div>
					</div>
					<span v-if="step5Status == 3" class="step-icon loading"><Loading type="spinner" size="0.2rem" /></span>
					<i v-else-if="step5Status == 1" class="step-icon van-icon van-icon-checked"></i>
					<i v-else-if="step5Status == 2" class="step-icon err van-icon van-icon-clear"></i>
				</div>
				<div class="step-action">
					<div v-if="step5Status == 1" class="step-text">已完成</div>
					<div v-else-if="firstFourDone && (step5Status == 0 || step5Status == 2)" class="step-btn" @click="onclickRestartBtn">重启</div>
					<div v-else-if="!firstFourDone" class="step-text">待上述4项质检完毕</div>
				</div>
			</div>
		</div>

		<!-- 底部提交按钮 -->
		<div class="footer">
			<div v-if="mode == 'check'" :class="['btn-submit', { disabled: !canSubmit }]" @click="onclickSubmitBtn">单独提交质检</div>
		</div>

		<!-- 打样视频照片弹框 -->
		<div v-if="showMediaModal" class="media-modal" @touchmove.prevent>
			<div class="media-box">
				<video
					v-if="currentIndex === 0 && videoUrl"
					ref="mediaVideo"
					controls
					playsinline
					webkit-playsinline
					:src="videoUrl"
					:poster="picUrl"
				></video>
				<img v-else :src="picUrl" @click="showPreviewImg = true" />
			</div>
			<div v-if="picUrl" class="media-list">
				<div
					class="item"
					:class="{ active: currentIndex === 0 }"
					@click="changeMediaIndex(0)"
				>
					<div class="img-box">
						<img :src="picUrl" />
						<div class="play-icon"></div>
					</div>
				</div>
				<div
					class="item"
					:class="{ active: currentIndex === 1 }"
					@click="changeMediaIndex(1)"
				>
					<div class="img-box">
						<img :src="picUrl" />
					</div>
				</div>
			</div>
			<div v-else class="media-empty">未获取到视频和照片</div>
			<img
				class="close-btn"
				src="https://static.yudada.com/wechat/pond/img/icon_close_modal.png"
				@click="closeMediaModal"
			/>
			<div v-if="showPreviewImg" class="preview-mask" @click="showPreviewImg = false">
				<img :src="picUrl" />
			</div>
		</div>

		<!-- 手动输入编号弹窗已移除，改为独立页面 manualInput -->
	</div>
</template>

<script>
import { Dialog, Toast, Loading } from 'vant';
export default {
	name: 'XiazengQaEngine',
	components: {
		Loading,
	},
	data() {
		const { ossHostPond } = this.$config.base;
		return {
			ossPondHost: ossHostPond,
			// 设备信息
			info: {},
			// 设备在列表中的索引
			deviceIndex: -1,
			// 模式: check=质检 view=查看
			mode: 'check',
			// 扫码获取的设备编号
			uniqueId: '',
			// 步骤状态 0=未开始 1=成功 2=失败 3=进行中
			step1Status: 0,
			step2Status: 0,
			step3Status: 0,
			step5Status: 0,
			// 前四项是否全部完成（除重启步骤外）
			firstFourDone: false,
			// 步骤4（信号强度）
			step4Status: 0,
			// 步骤4当前信号值
			signalValue: null,
			// 步骤4信号合格要求值（需≥此值）
			signalRequired: 25,
			// 步骤2失败原因
			step2FailReason: '',
			// 是否可以提交（五步全部成功）
			canSubmit: false,
			// 轮询定时器
			pollTimer: null,
			// 设备打样过程状态（含视频/照片地址）
			processState: {},
			// 打样视频照片弹框
			showMediaModal: false,
			showPreviewImg: false,
			currentIndex: 0,
			picUrl: '',
			videoUrl: '',
		};
	},
	computed: {
		// 当前信号值展示，无值时为 -
		displaySignal() {
			const value = this.signalValue;
			return value === null || value === undefined || value === '' ? '-' : value;
		},
	},
	created() {
		const vm = this;
		const { index, mode } = vm.$route.query;
		const deviceIndex = Number(index);
		vm.deviceIndex = deviceIndex;
		vm.mode = mode || 'check';

		// 从路由 state 获取设备列表信息（由 checkList 页传入）
		const listStr = sessionStorage.getItem('xiazengCheckList') || '[]';
		let preList = [];
		try { preList = JSON.parse(listStr); } catch (e) { preList = []; }
		const info = preList[deviceIndex] || {};
		info.displayImei = info.imei || '-';
		info.displayIccid = info.iccid || '-';
		vm.info = info;

		// 查看模式: 所有步骤显示已完成
		if (mode === 'view') {
			vm.step1Status = 1;
			vm.step2Status = 1;
			vm.step3Status = 1;
			vm.step4Status = 1;
			vm.step5Status = 1;
			vm.firstFourDone = true;
			vm.canSubmit = false;
			// 查看模式: 拉取一次设备详情获取打样媒体数据
			vm.fetchProcessMedia();
			return;
		}

		// 质检模式: 立即查询设备当前状态并开始轮询
		vm.pollDeviceStatus();
		vm.startPoll();
		// 初始化微信 JSSDK
		vm.weixinInit();

		// 检查从手动输入页返回的编号
		const manualUniqueId = sessionStorage.getItem('xiazengManualUniqueId');
		if (manualUniqueId) {
			sessionStorage.removeItem('xiazengManualUniqueId');
			vm.uniqueId = manualUniqueId;
			vm.doStep1();
		}
	},
	beforeDestroy() {
		this.stopPoll();
	},
	methods: {
		// ==================== 微信 JSSDK ====================
		weixinInit() {
			const vm = this;
			vm.$http({
				method: 'GET',
				url: `https://m.yudada.com/jssdk/configuration?url=${location.href}`,
			}).then(res => {
				const { appId, nonceStr, signature, timestamp } = res.data;
				window.wx.config({
					debug: false,
					appId,
					timestamp,
					nonceStr,
					signature,
					jsApiList: ['scanQRCode'],
				});
			});
		},

		// ==================== 轮询设备状态 ====================
		startPoll() {
			const vm = this;
			vm.stopPoll();
			vm.pollTimer = setInterval(() => {
				vm.pollDeviceStatus();
			}, 5000);
		},
		stopPoll() {
			if (this.pollTimer) {
				clearInterval(this.pollTimer);
				this.pollTimer = null;
			}
		},

		// 查询单台设备详情，更新各步骤状态
		pollDeviceStatus() {
			const vm = this;
			const { info } = vm;
			if (!info.iccid) return;
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/device/${info.iccid}`,
			}).then(res => {
				vm.updateStepStatus(res.data);
			}).catch(() => {});
		},

		// 根据设备详情更新步骤状态
		updateStepStatus(device) {
			const vm = this;
			const ps = (device && device.processState) || {};
			vm.processState = ps;

			// 步骤1: configState SENT/ACKED=进行中 SUCCESS=成功 FAILED/TIMEOUT=失败
			const configState = ps.configState || '';
			if (configState === 'SUCCESS') {
				vm.step1Status = 1;
				vm.uniqueId = ps.serverUniqueId || vm.uniqueId;
			} else if (configState === 'FAILED' || configState === 'TIMEOUT') {
				vm.step1Status = 2;
			} else if (configState === 'SENT' || configState === 'ACKED') {
				vm.step1Status = 3;
			}

			// 步骤2: sampleState CMD_SENT/CMD_ACKED/SAMPLING=检测中 COMPLETED=成功 FAILED/TIMEOUT=失败
			const sampleState = ps.sampleState || 'IDLE';
			if (sampleState === 'COMPLETED') {
				vm.step2Status = 1;
				vm.step2FailReason = '';
			} else if (sampleState === 'FAILED' || sampleState === 'TIMEOUT') {
				vm.step2Status = 2;
				vm.step2FailReason = vm.getStep2FailReason(ps, sampleState);
			} else if (sampleState === 'CMD_SENT' || sampleState === 'CMD_ACKED' || sampleState === 'SAMPLING') {
				vm.step2Status = 3;
				vm.step2FailReason = '';
			}

			// 步骤3: buttonChecked true=已完成
			vm.step3Status = ps.buttonChecked ? 1 : 0;

			// 步骤4（信号强度）: signalQualified true=通过 false=不通过
			vm.signalValue = ps.signal != null ? ps.signal : device.signal;
			if (device.signalQualified) {
				vm.step4Status = 1;
			} else {
				vm.step4Status = 2;
			}

			// 步骤5: formalRegisterState IDLE=空闲 WAITING=等待注册 SUCCESS=注册成功 TIMEOUT=超时失败
			const formalRegisterState = ps.formalRegisterState || 'IDLE';
			if (formalRegisterState === 'SUCCESS') {
				vm.step5Status = 1;
			} else if (formalRegisterState === 'TIMEOUT') {
				vm.step5Status = 2;
			} else if (formalRegisterState === 'WAITING') {
				vm.step5Status = 3;
			} else {
				vm.step5Status = 0;
			}

			vm.$nextTick(() => {
				vm.checkCanSubmit();
			});
		},

		// 解析步骤2失败原因
		getStep2FailReason(ps, sampleState) {
			const reasons = [];
			if (sampleState === 'TIMEOUT') reasons.push('检测超时');
			if (ps.deviceReportCompleted === false) reasons.push('打样上报失败');
			if (ps.forceRelaxed === false || ps.forceTightened === false || ps.topSwitchTriggered === false) reasons.push('未到达限位');
			if (ps.imageUploaded === false) reasons.push('图片上传失败');
			if (ps.videoUploaded === false) reasons.push('视频上传失败');
			return reasons.join('、');
		},

		// ==================== 打样媒体查看 ====================

		// videoUrl/imageUrl 兼容字符串或数组格式，取第一个有效值
		getUrl(val) {
			if (!val) return '';
			if (Array.isArray(val)) {
				return val.find((item) => !!item) || '';
			}
			return val;
		},

		// 查看模式: 拉取一次设备详情获取打样媒体数据
		fetchProcessMedia() {
			const vm = this;
			const { info } = vm;
			if (!info.iccid) return;
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/device/${info.iccid}`,
			}).then(res => {
				const device = res.data;
				if (device && device.processState) {
					vm.processState = device.processState;
				}
			}).catch(() => {});
		},

		openMediaModal() {
			const vm = this;
			const ps = vm.processState || {};
			vm.picUrl = vm.getUrl(ps.imageUrl);
			vm.videoUrl = vm.getUrl(ps.videoUrl);
			vm.showMediaModal = true;
			vm.showPreviewImg = false;
			vm.currentIndex = 0;
		},

		closeMediaModal() {
			this.showMediaModal = false;
			this.showPreviewImg = false;
			const video = this.$refs.mediaVideo;
			if (video) {
				video.pause();
			}
		},

		changeMediaIndex(index) {
			this.currentIndex = index;
		},

		// ==================== 步骤操作 ====================

		// 公共方法: 调用 workflow 接口下发指令
		doWorkflow(query, loadingText) {
			const vm = this;
			const { info } = vm;
			if (loadingText) {
				Toast.loading({ message: loadingText, forbidClick: true, duration: 2000 });
			}
			vm.$http({
				method: 'POST',
				url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/device/workflow/${info.iccid}?${query}`,
			}).then(() => {
				setTimeout(() => { vm.pollDeviceStatus(); }, 1000);
			}).catch(() => {});
		},

		// 步骤1: 扫码录入设备编号
		onclickScanBtn() {
			const vm = this;
			if (vm.mode === 'view') return;
			vm.uniqueId = '';
			// 使用微信 JSSDK 扫码
			if (window.wx && window.wx.scanQRCode) {
				window.wx.scanQRCode({
					needResult: 1,
					scanType: ['qrCode'],
					success(res) {
						const result = res.resultStr;
						if (result.indexOf('deviceId=') < 0) {
							Toast('请扫描正确的二维码');
							return;
						}
						const encodeId = result.split('deviceId=')[1];
						if (!encodeId) {
							Toast('请扫描正确的二维码');
							return;
						}
						const loading = Toast.loading({ message: '识别中', forbidClick: true, duration: 0 });
						vm.$http({
							method: 'GET',
							url: vm.$config.base.PROBE_BASE_URL + `device/info?encodeId=${encodeId}`,
						}).then(rs => {
							loading.clear();
							if (!rs.data.uniqueId) {
								Toast('未获取到设备编号');
								return;
							}
							vm.uniqueId = rs.data.uniqueId;
							vm.doStep1();
						}).catch(() => {
							loading.clear();
						});
					}
				});
			}
		},

		// 点击手动输入按钮，跳转手动输入编号页
		onclickManualBtn() {
			const vm = this;
			if (vm.mode === 'view') return;
			vm.$router.push({ path: './manualInput' });
		},

		// 步骤1: 下发配置 (step=1)
		doStep1() {
			const vm = this;
			const { uniqueId } = vm;
			vm.step1Status = 3;
			vm.doWorkflow(`step=1&uniqueId=${uniqueId}&hwVersion=0`, '下发配置中');
		},

		// 步骤2: 远程打样测试 (step=2)
		onclickRemoteTestBtn() {
			const vm = this;
			if (vm.mode === 'view') return;
			if (vm.step2Status === 3) return;
			vm.step2Status = 3;
			vm.doWorkflow('step=2', '远程打样检测中');
		},

		// 步骤5: 重启并切换到线上环境 (step=3)
		onclickRestartBtn() {
			const vm = this;
			if (vm.mode === 'view') return;
			if (vm.step5Status === 3) return;
			vm.step5Status = 3;
			const { uniqueId } = vm;
			const { USER_NAME } = vm.$config.keys;
			const operationName = vm.$localStorage.getItem(USER_NAME) || '';
			vm.doWorkflow(`step=3&uniqueId=${uniqueId}&operationName=${operationName}`, '下发重启指令中');
		},

		// 点击亮灯
		onclickLightBtn() {
			const vm = this;
			if (!vm.info.iccid) {
				Toast('设备ICCID为空');
				return;
			}
			const toast = Toast.loading({ message: '亮灯中...', forbidClick: true, duration: 0 });
			vm.$http({
				method: 'POST',
				url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/device/${vm.info.iccid}/light/blink?duration=5`,
			}).then(() => {
				toast.clear();
				Toast('设备指示灯已闪烁');
			}).catch(() => {
				toast.clear();
			});
		},

		// ==================== 提交 ====================

		// 判断是否可以提交（五步全部成功）
		checkCanSubmit() {
			const vm = this;
			const firstFourDone = vm.step1Status === 1 && vm.step2Status === 1 && vm.step3Status === 1 && vm.step4Status === 1;
			const canSubmit = firstFourDone && vm.step5Status === 1;
			vm.firstFourDone = firstFourDone;
			vm.canSubmit = canSubmit;
		},

		// 确认正式服务登录
		onclickSubmitBtn() {
			const vm = this;
			if (!vm.canSubmit) return;
			const { uniqueId } = vm;
			Dialog.confirm({
				title: '质检提示',
				message: `设备${uniqueId}已通过全部质检项，是否提交质检结果？`,
				confirmButtonText: '提 交',
				cancelButtonText: '取 消',
			}).then(() => {
				vm.confirmSubmit();
			}).catch(() => {});
		},

		// 确认提交 - 调用 confirmServerLogin 确认正式服务登录
		confirmSubmit() {
			const vm = this;
			const { uniqueId } = vm;
			const toast = Toast.loading({ message: '提交中', forbidClick: true, duration: 0 });
			vm.$http({
				method: 'POST',
				url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/confirmServerLogin?uniqueId=${uniqueId}`,
			}).then(() => {
				toast.clear();
				Toast('质检提交成功');
				setTimeout(() => {
					vm.$router.back();
				}, 1500);
			}).catch(() => {
				toast.clear();
			});
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-qa-engine {
	min-height: 100vh;
	background: @bgColor2;
	padding: 0.1rem 0.1rem 0.9rem;
	box-sizing: border-box;

	.device-header {
		display: flex;
		align-items: flex-start;
		padding: 0.1rem 0;

		.device-left {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-right: 0.1rem;
			flex-shrink: 0;
		}

		.device-icon {
			width: 0.8rem;
			height: 0.8rem;
		}

		.device-light-btn {
			margin-top: 0.06rem;
			border: 2px solid @themeColor;
			border-radius: 0.12rem;
			color: @themeColor;
			font-size: 0.18rem;
			line-height: 0.24rem;
			padding: 0 0.1rem;
			text-align: center;
			cursor: pointer;
			width: 0.75rem;
			box-sizing: border-box;
		}

		.device-num {
			font-size: 0.18rem;
			color: @textColor12;
			font-weight: 500;
			letter-spacing: 0.01rem;
			line-height: 0.22rem;
			word-break: break-all;
		}
	}

	.steps {
		margin-top: 0.1rem;

		.step-item {
			background: @blank;
			border-radius: 0.05rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0.25rem 0.1rem;
			box-sizing: border-box;

			&.disabled {
				opacity: 0.5;
			}

			& + .step-item {
				margin-top: 0.15rem;
			}

			.step-left {
				display: flex;
				align-items: center;

				.step-info {
					display: flex;
					flex-direction: column;
				}

				.step-label {
					font-size: 0.18rem;
					color: @textColor12;
					font-weight: 500;
					letter-spacing: 0.01rem;
					line-height: 0.25rem;
				}

				.step-sub {
					font-size: 0.14rem;
					color: @textColor12;
					font-weight: 500;
					letter-spacing: 0.01rem;
					line-height: 0.25rem;

					&.fail {
						color: #FF005F;
					}
				}

				.step-icon {
					color: @themeColor;
					font-size: 0.22rem;
					margin-left: 0.08rem;

					&.err {
						color: #FF005F;
					}

					&.loading {
						width: 0.2rem;
						height: 0.2rem;
						display: inline-flex;
						align-items: center;
						justify-content: center;
					}
				}
			}

			.step-action {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				flex-shrink: 0;
				max-width: 1.8rem;
				text-align: right;

				.step-action-btns {
					display: flex;
					gap: 0.1rem;
				}

				.step-btn {
					background: @blank;
					border-radius: 0.15rem;
					border: 2px solid @textColor1;
					color: @textColor1;
					font-size: 0.18rem;
					letter-spacing: 0.01rem;
					line-height: 0.25rem;
					padding: 0.02rem 0.1rem;
					cursor: pointer;
				}

				.step-text {
					color: @textColor1;
					font-size: 0.18rem;
					letter-spacing: 0.01rem;
					line-height: 0.25rem;

					&.success {
						color: @themeColor;
					}

					&.yellow {
						color: #FF7C00;
					}
				}
			}
		}
	}

	.confirm-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 0.05rem;
		padding: 0.14rem 0.15rem;
		margin: 0 0 0.15rem 0;
		cursor: pointer;

		.confirm-text {
			font-size: 0.16rem;
			color: @textColor12;
		}

		.confirm-btn {
			font-size: 0.16rem;
			color: @themeColor;
			font-weight: bold;
		}
	}

	.media-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		z-index: 99;
		color: @blank;
		padding: 0.3rem 0.1rem;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;

		.media-box {
			width: 100%;
			height: 2.25rem;
			display: flex;
			justify-content: center;
			align-items: center;
			overflow: hidden;

			video,
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		.media-list {
			margin-top: 0.37rem;
			display: flex;

			.item {
				height: 0.75rem;
				width: 0.75rem;
				margin-right: 0.1rem;
				border-radius: 0.05rem;

				.img-box {
					position: relative;
					height: 0.75rem;
					width: 0.75rem;
					border: 0.02rem solid #313232;
					border-radius: 0.05rem;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					align-items: center;
					overflow: hidden;

					img {
						height: 100%;
						width: 100%;
						border-radius: 0.05rem;
					}

					.play-icon {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 0;
						height: 0;
						border-left: 0.1rem solid rgba(255, 255, 255, 0.9);
						border-top: 0.07rem solid transparent;
						border-bottom: 0.07rem solid transparent;
					}
				}

				&.active {
					.img-box {
						border-color: @themeColor;
					}
				}
			}
		}

		.media-empty {
			margin-top: 0.37rem;
			text-align: center;
			color: @blank;
		}

		.close-btn {
			position: fixed;
			left: 50%;
			bottom: 0.6rem;
			transform: translateX(-50%);
			width: 0.5rem;
			height: 0.5rem;
		}

		.preview-mask {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.9);
			z-index: 100;
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}

	.footer {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 20;

		.btn-submit {
			background: @themeColor;
			color: @blank;
			font-size: 0.19rem;
			font-weight: 500;
			letter-spacing: 0.025rem;
			line-height: 0.27rem;
			text-align: center;
			padding: 0.17rem 0 0.16rem;
			cursor: pointer;

			&.disabled {
				background: @textColor13;
				cursor: default;
			}
		}
	}
}
</style>
